/* eslint-disable import/no-cycle */
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core'

import { FlxStyleModule, FlxWrapperStyleDirective } from '@flowx/angular-theme'
import { CardHeaderActionsTemplateConfig } from '@flowx/core-sdk'

import { FlxTreeNodeComponent } from '../../renderer/tree-node/tree-node.component'

@Component({
  selector: 'flx-card-header-actions-wrapper',
  hostDirectives: [
    { directive: FlxWrapperStyleDirective, inputs: ['flxWrapperStyle: templateConfig'] },
  ],
  imports: [FlxTreeNodeComponent, FlxStyleModule],
  template: `
    <flx-tree-node
      [templateConfig]="templateConfig()"
      [flxLayoutStyle]="{ style: style(), componentType: 'card-header-actions' }"
      class="flx-card-header-actions"
    />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlxCardHeaderActionsWrapperComponent {
  templateConfig = input.required<CardHeaderActionsTemplateConfig>()

  displayOptions = computed(() => this.templateConfig().displayOptions)
  style = computed(() => this.displayOptions().style)
}
